import DatabaseConfigs from './components/DatabaseConfigs';

export default DatabaseConfigs;
